import styled from '@emotion/styled'
import { COLORS } from 'theme/theme'

export const Container = styled.div`
  border-bottom: solid 1px ${COLORS.grayLighter};
  padding: 10px 20px;

  &:hover {
    background-color: ${COLORS.grayExtraLighter};
  }
`
